import type { CSSProperties } from 'react';
import styles from './Icon.module.css';

export interface IconProps {
  /** Material Icons ligature name, e.g. "desktop_windows". */
  name: string;
  /** px; DS sizes are 11–13 inline, 14 dense, 16 nav, 20 and 24 tiles. `'1em'` follows the font size. */
  size?: number | '1em';
  /** Set when the icon is the only signal; otherwise it is hidden from assistive tech. */
  label?: string;
  /** Filled style, for deliberate state glyphs only. */
  filled?: boolean;
  className?: string;
  style?: CSSProperties;
}

/** DS Icon: Material Icons Outlined. */
export function Icon({
  name,
  size = 16,
  label,
  filled = false,
  className,
  style,
}: IconProps) {
  const a11y = label
    ? { role: 'img', 'aria-label': label }
    : { 'aria-hidden': true };
  return (
    <span
      {...a11y}
      translate="no"
      data-filled={filled || undefined}
      className={className ? `${styles.icon} ${className}` : styles.icon}
      style={{ fontSize: size, width: size, height: size, ...style }}
    >
      {name}
    </span>
  );
}
